import { Inject, Injectable, Injector } from '@angular/core';
import { HttpClient, HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';


@Injectable()
export class WithCredentialsInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return next.handle(req.clone({withCredentials: true}));
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/interceptors/with-credentials.interceptor.ts